import axios from "axios";
import { geoServerBaseUrl, bun_server } from "./baseUrl";
import get_aggregate_train from "../validation/get_aggregate_train";
import { getProjectDetailByLink } from "./projectActions";
import { getDetailLayerById } from "./get_features_action";

import { edit_child_cell } from "./crudNestedTable";
import { editPropertiesV2 } from "./layerActions";

const SERVER_URL = geoServerBaseUrl;

/*NON-API*/

const calculate_time_delta = (date) => {
  const now = Date.now();
  const feature_date = date ? new Date(date) : new Date(0);
  const delta_ms = now - feature_date.getTime();
  let remaining_days = Math.floor(delta_ms / (1000 * 60 * 60 * 24));
  const years_count = Math.floor(remaining_days / 365);
  remaining_days -= years_count * 365;
  const months_count = Math.floor(remaining_days / 30);
  remaining_days -= months_count * 30;
  return {
    years_count,
    months_count,
    days_count: remaining_days,
  };
};

const sort_features = (
  features,
  sorted_field,
  sorted_mode,
  sorted_field_type,
) => {
  if (!sorted_field) return features;
  return [...features].sort((a, b) => {
    if (sorted_field_type === "date") {
      const date_a = a.properties[sorted_field]
        ? new Date(a.properties[sorted_field])
        : new Date(0);
      const date_b = b.properties[sorted_field]
        ? new Date(b.properties[sorted_field])
        : new Date(0);
      return sorted_mode === "asc" ? date_a - date_b : date_b - date_a;
    }
    const value_a = a.properties[sorted_field];
    const value_b = b.properties[sorted_field];
    if (value_a == null && value_b == null) return 0;
    if (value_a == null) return sorted_mode === "asc" ? 1 : -1;
    if (value_b == null) return sorted_mode === "asc" ? -1 : 1;
    if (sorted_field_type === "number") {
      const num_a = Number(value_a);
      const num_b = Number(value_b);
      return sorted_mode === "asc" ? num_a - num_b : num_b - num_a;
    }
    const str_a = String(value_a).toLowerCase();
    const str_b = String(value_b).toLowerCase();
    return sorted_mode === "asc"
      ? str_a.localeCompare(str_b)
      : str_b.localeCompare(str_a);
  });
};

export const clear_layer_id = () => {
  return {
    type: "clear_layer_id",
  };
};

export const set_loading = (itemLoading) => {
  return {
    type: "set_loading",
    payload: itemLoading,
  };
};

export const clear_loading = () => {
  return {
    type: "clear_loading",
  };
};

export const set_value_properties = (body) => {
  return {
    type: "set_value_properties",
    payload: body,
  };
};

export const push_value_properties = (body) => {
  return {
    type: "push_value_properties",
    payload: body,
  };
};

export const pull_value_properties_string = (body) => {
  return {
    type: "pull_value_properties_string",
    payload: body,
  };
};

export const pull_value_properties_object = (body) => {
  return {
    type: "pull_value_properties_object",
    payload: body,
  };
};

export const aggregate_train = (body) => {
  /*
  const body = {
        geo_layer,
        start,
        end,
        field_key,
      };

  */
  const chart_js_aggregate_train = get_aggregate_train(body);
  return {
    type: "set_value_properties",
    payload: {
      key: "chart_js_aggregate_train",
      value: chart_js_aggregate_train,
    },
  };
};

/*POST METHODE*/

/**
 * @name : set_is_cluster
 * @endpoint : /properties/set_is_cluster
 * @body : geo_layer_id, is_cluster
 * @query : -
 * @methode : put
 */
export const set_is_cluster = (body) => async (dispatch) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    dispatch({
      type: "set_loading_action",
      payload: "set_is_cluster",
    });
    await axios.put(SERVER_URL + "/properties/set_is_cluster", body, config);
    dispatch({
      type: "set_inside_geo_layer",
      payload: {
        key: "is_cluster",
        value: body.is_cluster,
        geo_layer_id: body.geo_layer_id,
      },
    });
    dispatch({
      type: "status_action",
    });
    dispatch({
      type: "clear_loading_action",
      payload: "set_is_cluster",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "set_is_cluster",
    });
  }
};

/**
 * @name : push_style_array
 * @endpoint : /properties/push_style_array
 * @body : geo_layer_id, style_object
 * @query : -
 * @methode : post
 */
export const push_style_array = (body) => async (dispatch) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    dispatch({
      type: "set_loading_action",
      payload: "push_style_array",
    });
    await axios.post(SERVER_URL + "/properties/push_style_array", body, config);
    dispatch({
      type: "push_inside_geo_layer",
      payload: {
        key: "style_array",
        value: body.style_object,
        geo_layer_id: body.geo_layer_id,
      },
    });
    dispatch({
      type: "set_inside_geo_layer",
      payload: {
        key: "default_style_key",
        value: body.style_object.key,
        geo_layer_id: body.geo_layer_id,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "push_style_array",
    });
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "layer_style_step",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "is_preview_on",
        value: false,
      },
    });
    dispatch({
      type: "status_action",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "push_style_array",
    });
  }
};

/**
 * @name : set_style_array
 * @endpoint : /properties/set_style_array
 * @body : geo_layer_id, paint_object_edited
 * @query : -
 * @methode : put
 */
export const set_style_array = (body) => async (dispatch) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    dispatch({
      type: "set_loading_action",
      payload: "set_style_array",
    });
    await axios.put(SERVER_URL + "/properties/set_style_array", body, config);
    dispatch({
      type: "set_inside_array_geo_layer",
      payload: {
        geo_layer_id: body.geo_layer_id,
        key: "style_array",
        key_id_child: "key",
        value_id_child: body?.style_object?.key,
        value: body.style_object,
      },
    });
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "layer_style_step",
        value: 0,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "set_style_array",
    });
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "is_preview_on",
        value: false,
      },
    });
    dispatch({
      type: "status_action",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "set_style_array",
    });
  }
};

/**
 * @name : pull_style_array
 * @endpoint : /properties/pull_style_array
 * @body : geo_layer_id, style_key
 * @query : -
 * @methode : put
 */
export const pull_style_array = (body) => async (dispatch) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    dispatch({
      type: "set_loading_action",
      payload: "pull_style_array",
    });
    await axios.put(SERVER_URL + "/properties/pull_style_array", body, config);
    dispatch({
      type: "pull_inside_array_geo_layer",
      payload: {
        geo_layer_id: body.geo_layer_id,
        key: "style_array",
        key_id_child: "key",
        value_id_child: body.style_key,
      },
    });
    dispatch({
      type: "status_action",
    });
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "is_preview_on",
        value: false,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "pull_style_array",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "pull_style_array",
    });
  }
};

/**
 * @name : set_default_style_key
 * @endpoint : /properties/set_default_style_key
 * @body : geo_layer_id, style_key
 * @query : -
 * @methode : put
 */
export const set_default_style_key = (body) => async (dispatch) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    dispatch({
      type: "set_loading_action",
      payload: "set_default_style_key",
    });
    await axios.put(
      SERVER_URL + "/properties/set_default_style_key",
      body,
      config,
    );
    dispatch({
      type: "set_inside_geo_layer",
      payload: {
        key: "default_style_key",
        value: body.style_key,
        geo_layer_id: body.geo_layer_id,
      },
    });
    dispatch({
      type: "status_action",
    });
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "is_preview_on",
        value: false,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "set_default_style_key",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "set_default_style_key",
    });
  }
};

/**
 * @name : edit_label_config
 * @endpoint : /properties/edit_label_config
 * @body : geo_layer_id, label_config
 * @query :
 * @methode : post
 */
export const edit_label_config = (body) => async (dispatch) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    dispatch({
      type: "set_loading_action",
      payload: "edit_label_config",
    });
    await axios.post(
      SERVER_URL + "/properties/edit_label_config",
      body,
      config,
    );
    dispatch({
      type: "set_inside_geo_layer",
      payload: {
        key: "label_config",
        value: body.label_config,
        geo_layer_id: body.geo_layer_id,
      },
    });
    dispatch({
      type: "status_action",
    });
    dispatch({
      type: "clear_loading_action",
      payload: "edit_label_config",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "edit_label_config",
    });
  }
};

export const push_resume_kai = (body) => async (dispatch) => {
  //push_resume_kai
  /*
  body = {
    geo_project_id,
    folder_id,
    geo_layer_id,
    year,
    timeseries_object = {
      timeseries_mode: "kai",
      field_name_array_month: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MEI",
        "JUN",
        "JUL",
        "AGS",
        "SEP",
        "OKT",
        "NOV",
        "DES",
      ],
      field_name_relasi: "RELASI",
      field_name_jumlah_kereta: "Jumlah KA per 30 menit",
      field_name_jumlah_pnp: "Jumlah pnp 30 menit",
      field_name_grand_total: "Grand Total",
      field_name_max_per_kereta: "Max per Kereta",
      field_name_jam_berangkat: "JAM BERANGKAT",
      field_name_jam_datang: "JAM DATANG",
    }
  }
  */

  try {
    dispatch(set_loading("push_resume_kai"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.post(
      SERVER_URL + "/chart_editors/push_resume_kai",
      body,
      config,
    );
    dispatch({
      type: "push_resume_kai",
      payload: body,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const reset_resume_kai = (body) => async (dispatch) => {
  //reset_resume_kai
  /*
  body = {
    geo_project_id,
    folder_id,
  }
  */

  try {
    dispatch(set_loading("reset_resume_kai"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.post(
      SERVER_URL + "/chart_editors/reset_resume_kai",
      body,
      config,
    );
    dispatch({
      type: "reset_resume_kai",
      payload: body,
    });
    dispatch({
      type: "status_action",
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const push_chart_list = (body) => async (dispatch) => {
  //push_chart_list
  /*
   const geo_layer_id = req.body.geo_layer_id;
   let chart_object = req.body.chart_object;
   chart_object = {
      ina                      : String, //judul bahasa indonesia
      eng                      : String, //judul bahasa inggris
      x_axis_field_key         : String,
      y_axis_field_key         : String,
      chart_type               : String, //line || bar || pie
      x_element_custom_order   : Array,
      color_default            : String,
      color_hover              : String,
      is_npv_kai               : Boolean,
      wacc_field_key           : String
  }
  */
  try {
    dispatch(set_loading("push_chart_list"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      SERVER_URL + "/chart_editors/push_chart_list",
      body,
      config,
    );
    dispatch({
      type: "push_chart_list",
      payload: res.data,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const edit_chart_list = (body) => async (dispatch) => {
  //edit_chart_list
  /*
   const geo_layer_id = req.body.geo_layer_id;
   let chart_object = req.body.chart_object;
   chart_object = {
      ina                      : String, //judul bahasa indonesia
      eng                      : String, //judul bahasa inggris
      x_axis_field_key         : String,
      y_axis_field_key         : String,
      chart_type               : String, //line || bar || pie
      x_element_custom_order   : Array,
      color_default            : String,
      color_hover              : String,
      is_npv_kai               : Boolean,
      wacc_field_key           : String
  }
  */
  try {
    dispatch(set_loading("edit_chart_list"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.put(
      SERVER_URL + "/chart_editors/edit_chart_list",
      body,
      config,
    );
    dispatch({
      type: "edit_chart_list",
      payload: body,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const clone_layer = (body, geo_project_link) => async (dispatch) => {
  //clone_layer
  /*
  const body = {
  "geo_layer_id": "649fb6e7fda52321502ed33d",
  "geo_project_id": "63dcf592a54b9cc8ee2f308e",
  "user_id": "5cb88367ce451995f7ed86f2",
  "new_name": "MACHRUS TEST APRAISAL"
}
*/
  try {
    dispatch(set_loading("clone_layer"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    await axios.post(SERVER_URL + "/properties/clone_layer", body, config);

    if (geo_project_link) {
      await dispatch(getProjectDetailByLink(geo_project_link));
    }
    // dispatch({
    //   type: "clone_layer",
    //   payload: body,
    // });

    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const edit_radius_pembanding = (body) => async (dispatch) => {
  //edit_radius_pembanding
  /*
  const body = {
    geo_layer_id,
    radius_pembanding
  }
  */
  try {
    dispatch(set_loading("edit_radius_pembanding"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    await axios.post(
      SERVER_URL + "/properties/edit_radius_pembanding",
      body,
      config,
    );

    dispatch({
      type: "edit_radius_pembanding",
      payload: body,
    });

    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const edit_percent_value_field_key = (body) => async (dispatch) => {
  //edit_percent_value_field_key
  /*
  const body = {
    geo_layer_id,
    field_key
  }
  */
  try {
    dispatch(set_loading("edit_percent_value_field_key"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.post(
      SERVER_URL + "/properties/edit_percent_value_field_key",
      body,
      config,
    );
    dispatch({
      type: "edit_percent_value_field_key",
      payload: body,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const edit_rev_calculation_field_key = (body) => async (dispatch) => {
  //edit_rev_calculation_field_key
  /*
  const body = {
    geo_layer_id,
    field_key
  }
  */
  try {
    dispatch(set_loading("edit_rev_calculation_field_key"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    await axios.post(
      SERVER_URL + "/properties/edit_rev_calculation_field_key",
      body,
      config,
    );

    dispatch({
      type: "edit_rev_calculation_field_key",
      payload: body,
    });

    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const edit_final_calculation_field_key = (body) => async (dispatch) => {
  //edit_final_calculation_field_key
  /*
  const body = {
    geo_layer_id,
    field_key
  }
  */
  try {
    dispatch(set_loading("edit_final_calculation_field_key"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    await axios.post(
      SERVER_URL + "/properties/edit_final_calculation_field_key",
      body,
      config,
    );

    dispatch({
      type: "edit_final_calculation_field_key",
      payload: body,
    });

    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const edit_laporan_pdf = (body) => async (dispatch) => {
  //edit_laporan_pdf
  try {
    dispatch(set_loading("edit_laporan_pdf"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    await axios.post(SERVER_URL + "/properties/edit_laporan_pdf", body, config);

    dispatch({
      type: "edit_laporan_pdf",
      payload: body,
    });

    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

/*GET METHODE*/

export const get_detail_many_layer = (params) => async (dispatch) => {
  //get_detail_many_layer
  try {
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "still_loading_many_layer",
        value: true,
      },
    });

    const { layer_list, geo_project_id, folder_id } = params;

    dispatch(set_loading("get_detail_many_layer"));
    const delay_c = 0;
    const delay = () => new Promise((res) => setTimeout(res, delay_c));
    const parent_function = () => {
      return layer_list.reduce(
        (last_promise, object) =>
          last_promise.then((result_sum) =>
            child_function(object).then((result_current) => [
              ...result_sum,
              result_current,
            ]),
          ),
        Promise.resolve([]),
      );
    };

    const child_function = async (geo_layer_id) => {
      return delay().then(() => {
        const core_function = async () => {
          try {
            const params = {
              is_ignore_set_layer_id: true,
              geo_layer_id,
              geo_project_id,
              folder_id,
            };
            await dispatch(getDetailLayerById(params));
            dispatch(clear_loading());
          } catch (error) {
            dispatch(clear_loading());
          }
        };
        return core_function();
      });
    };

    await parent_function().then(() => {
      dispatch({
        type: "status_action",
      });
      dispatch(clear_loading());
      dispatch({
        type: "set_value_properties",
        payload: {
          key: "still_loading_many_layer",
          value: false,
        },
      });
    });
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const get_quota_price_list = () => async (dispatch) => {
  //get_quota_price_list
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    const res = await axios.get(
      SERVER_URL + "/admin_informations/get_quota_price_list",
      config,
    );

    dispatch({
      type: "set_value_properties",
      payload: {
        key: "quota_price_list",
        value: res.data,
      },
    });
  } catch (error) {
    dispatch(clear_loading());
  }
};

/*DELETE METHODE*/

export const delete_resume_kai = (body) => async (dispatch) => {
  //delete_resume_kai
  /*
  body = {
    geo_project_id,
    folder_id,
    geo_layer_id,
    year,
  }
  */

  try {
    dispatch(set_loading("push_resume_kai"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.delete(
      SERVER_URL + "/chart_editors/delete_resume_kai",
      body,
      config,
    );
    dispatch({
      type: "delete_resume_kai",
      payload: body,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const delete_chart_list = (params) => async (dispatch) => {
  //delete_chart_list
  /*
  params = {
    geo_project_id,
    chart_id
  }
  */
  try {
    dispatch(set_loading("delete_chart_list"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.delete(
      SERVER_URL +
        `/chart_editors/delete_chart_list?geo_layer_id=${params.geo_layer_id}&chart_id=${params.chart_id}`,
      config,
    );
    dispatch({
      type: "delete_chart_list",
      payload: params,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

//FOLDER CHART

export const push_folder_chart_list = (body) => async (dispatch) => {
  //push_folder_chart_list
  /*
   const geo_layer_id = req.body.geo_layer_id;
   let folder_chart_object = req.body.folder_chart_object;
   folder_chart_object = {
     title : String,
     key   : String
  }
  */
  try {
    dispatch(set_loading("push_folder_chart_list"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      "https://betaserver.mapid.io/chart_editors/push_folder_chart_list",
      body,
      config,
    );
    dispatch({
      type: "push_folder_chart_list",
      payload: res.data,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const edit_folder_chart_list = (body) => async (dispatch) => {
  //edit_folder_chart_list
  /*
   const geo_layer_id = req.body.geo_layer_id;
   let folder_chart_object = req.body.folder_chart_object;
   folder_chart_object = {
     title : String,
     key   : String
  }
  */
  try {
    dispatch(set_loading("edit_folder_chart_list"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.put(
      "https://betaserver.mapid.io/chart_editors/edit_folder_chart_list",
      body,
      config,
    );
    dispatch({
      type: "edit_folder_chart_list",
      payload: body,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const delete_folder_chart_list = (params) => async (dispatch) => {
  //delete_folder_chart_list
  /*
  params = {
    geo_layer_id,
    folder_chart_id
  }
  */
  try {
    dispatch(set_loading("delete_folder_chart_list"));
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.delete(
      `https://betaserver.mapid.io/chart_editors/delete_folder_chart_list?geo_layer_id=${params.geo_layer_id}&folder_chart_id=${params.folder_chart_id}`,
      config,
    );
    dispatch({
      type: "delete_folder_chart_list",
      payload: params,
    });
    dispatch(clear_loading());
  } catch (e) {
    dispatch(clear_loading());
  }
};

export const edit_side_table_object = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "edit_side_table_object",
    });

    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.put(
      bun_server + "/sini_v2/ss_formula/edit_side_table_object",
      body,
      config,
    );
    const { layer_id, side_table_object } = body;
    dispatch({
      type: "set_inside_geo_layer",
      payload: {
        key: "side_table_object",
        value: side_table_object,
        geo_layer_id: layer_id,
      },
    });
    const state = getState();
    const { geo_layer_list } = state.layer;
    let features =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer?.geojson?.features || [];
    const fields =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer?.fields || [];
    const { sorted_field, sorted_number, sorted_mode } = side_table_object;
    if (sorted_field) {
      const sorted_field_object = fields.find(
        (item) => item.key === sorted_field,
      );
      const sorted_field_type = sorted_field_object?.type || "text";
      features = sort_features(
        features,
        sorted_field,
        sorted_mode,
        sorted_field_type,
      );
      if (sorted_field_type === "date") {
        features = features.map((feature) => ({
          ...feature,
          ...calculate_time_delta(feature.properties[sorted_field]),
        }));
      }
    }
    if (side_table_object?.is_show_all === "no") {
      features = features.slice(0, Number(sorted_number));
    }
    dispatch({
      type: "replace_features_filtered",
      payload: {
        geo_layer_id: layer_id,
        features,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "edit_side_table_object",
    });
    dispatch({
      type: "status_action",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "edit_side_table_object",
    });
  }
};

export const reset_geojson_filtered = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { geo_layer_list, layer_id } = state.layer;
    let features =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer?.geojson?.features || [];
    const fields =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer?.fields || [];
    const side_table_object =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer?.side_table_object || {};
    const { sorted_field, sorted_number, sorted_mode } = side_table_object;
    if (sorted_field) {
      const sorted_field_object = fields.find(
        (item) => item.key === sorted_field,
      );
      const sorted_field_type = sorted_field_object?.type || "text";
      features = sort_features(
        features,
        sorted_field,
        sorted_mode,
        sorted_field_type,
      );
      if (sorted_field_type === "date") {
        features = features.map((feature) => ({
          ...feature,
          ...calculate_time_delta(feature.properties[sorted_field]),
        }));
      }
    }
    if (side_table_object?.is_show_all === "no") {
      features = features.slice(0, Number(sorted_number));
    }
    dispatch({
      type: "replace_features_filtered",
      payload: {
        geo_layer_id: layer_id,
        features,
      },
    });

    dispatch({
      type: "fly_action",
    });
    dispatch({
      type: "status_action",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "edit_side_table_object",
    });
  }
};

export const show_all_geojson_filtered = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { geo_layer_list, layer_id } = state.layer;
    let features =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer?.geojson?.features || [];
    const fields =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer?.fields || [];
    const side_table_object =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer?.side_table_object || {};
    const { sorted_field, sorted_mode } = side_table_object;

    features = features.map((feature) => ({
      ...feature,
      ...calculate_time_delta(feature.date_in),
    }));

    if (sorted_field) {
      const sorted_field_object = fields.find(
        (item) => item.key === sorted_field,
      );
      const sorted_field_type = sorted_field_object?.type || "text";
      features = sort_features(
        features,
        sorted_field,
        sorted_mode,
        sorted_field_type,
      );
      if (sorted_field_type === "date") {
        features = features.map((feature) => ({
          ...feature,
          ...calculate_time_delta(feature.properties[sorted_field]),
        }));
      }
    }

    dispatch({
      type: "replace_features",
      payload: {
        geo_layer_id: layer_id,
        features,
      },
    });

    dispatch({
      type: "fly_action",
    });
    dispatch({
      type: "status_action",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "edit_side_table_object",
    });
  }
};

export const get_administrasi = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_administrasi",
    });
    const { body_api, body_database, is_nested } = body;
    const { lat, long, mode } = body_api;
    const res = await axios.get(
      SERVER_URL +
        `/sini/generate_city_name?lat=${lat}&long=${long}&mode=${mode}`,
    );
    const value = res?.data || "Not found";
    body_database.properties_value = value;
    if (is_nested) {
      dispatch(edit_child_cell(body_database));
    } else {
      dispatch(editPropertiesV2(body_database));
    }
    dispatch({
      type: "clear_loading_action",
      payload: "get_administrasi",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_administrasi",
    });
  }
};

export const get_address = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_address",
    });

    const { body_api, body_database, is_nested, mode } = body;
    const { lat, long } = body_api;

    // Fetch data from Nominatim
    const res = await axios.get(
      `https://nominatim.mapid.io/reverse?lat=${lat}&lon=${long}&format=json`,
    );

    let value;
    const data = res?.data || {};
    const address = data.address || {};

    // Deconstruct useful fields for cleaner code
    const { name, display_name, class: osmClass, type: osmType } = data;

    // Helper function to capitalize generic types
    const capitalizeFirstLetter = (string) => {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    // Helper function to append the OSM type in parentheses (ignoring generic "yes" tags)
    const formatWithNameAndType = (poiName) => {
      if (osmType && osmType !== "yes") {
        return `${poiName} (${osmType})`;
      }
      return poiName;
    };

    // Array of OSM types that make good generic POI descriptions
    const genericTypes = [
      "residential",
      "commercial",
      "industrial",
      "retail",
      "cemetery",
      "apartments",
      "house",
      "warehouse",
      "parking",
      "park",
      "playground",
      "forest",
      "farmland",
      "garage",
      "garages",
      "dormitory",
      "meadow",
      "beach",
      "graveyard",
      "place_of_worship",
    ];

    if (mode === "auto_address") {
      value = display_name || "Not found";
    } else {
      // --- AUTO_ADDRESS_POI LOGIC ---

      // 1. Direct explicit name (Highest priority - e.g., "Starbucks (cafe)")
      if (name) {
        value = formatWithNameAndType(name);
      }
      // 2. Dynamic matching: POI name stored in an address key matching its type/class
      else if (osmType && address[osmType]) {
        value = formatWithNameAndType(address[osmType]);
      } else if (osmClass && address[osmClass]) {
        value = formatWithNameAndType(address[osmClass]);
      }
      // 3. Common OSM business/landmark categories
      else if (
        address.amenity ||
        address.shop ||
        address.tourism ||
        address.leisure ||
        address.office ||
        address.building ||
        address.historic
      ) {
        const categoryName =
          address.amenity ||
          address.shop ||
          address.tourism ||
          address.leisure ||
          address.office ||
          address.building ||
          address.historic;

        value = formatWithNameAndType(categoryName);
      }
      // 4. Generic types WITH City/County appended (e.g., "Residential in Kabupaten Bandung")
      else if (genericTypes.includes(osmType)) {
        const genericName = capitalizeFirstLetter(osmType);
        // Look for the most relevant regional identifier
        const regionName =
          address.city || address.county || address.town || address.village;

        if (regionName) {
          value = `${genericName} in ${regionName}`;
        } else {
          value = genericName; // Fallback if no region is found
        }
      }
      // 5. Road/highway fallback (e.g., user clicked a street)
      else if (osmClass === "highway" && address.road) {
        value = address.road;
      }
      // 6. Final Fallback: No nearby buildings
      else {
        value = display_name
          ? `[No nearby buildings] ${display_name}`
          : "Not found";
      }
    }

    // --- DATABASE UPDATE BLOCK ---
    body_database.properties_value = value;
    if (is_nested) {
      dispatch(edit_child_cell(body_database));
    } else {
      dispatch(editPropertiesV2(body_database));
    }

    dispatch({
      type: "clear_loading_action",
      payload: "get_address",
    });
  } catch (e) {
    console.error("Geocoding error:", e);
    dispatch({
      type: "clear_loading_action",
      payload: "get_address",
    });
  }
};
